import { HomeTwoTone, ImageTwoTone } from '@mui/icons-material';
import { Box, Step, StepLabel, Stepper, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const steps = [
  { label: 'የወረዳ ዋና መረጃ ', icon: <HomeTwoTone /> },
  { label: 'የወረዳ መገለጫ ምስል', icon: <ImageTwoTone /> },
];

export default function FormProgress({ activeStep }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Typography variant="h6" gutterBottom sx={{color: 'text.secondary'}}>
        አዲስ ወረዳ ጨምር
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map(({ label, icon }, index) => (
            <Step key={label}>
              <StepLabel icon={icon} sx={{ color: index <= activeStep ? 'teal' : 'inherit' }}>
                <Box sx={{ color: index <= activeStep ? 'teal' : 'inherit' }}>{label}</Box>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
      <>.</>
    </Box>
  );
}

FormProgress.propTypes = {
  activeStep: PropTypes.number.isRequired,
};
